import styled from "styled-components";

export const Wrapper = styled.footer`
    background: rgba(5, 5, 5, 0.95);
    border-top: 1px solid var(--cardBorder);
    padding: 60px 5% 20px;
    width: 100%;

    @media (max-width: 768px) {
        padding: 48px 16px 20px;
    }
`;

export const Content = styled.div`
    max-width: var(--maxWidth);
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        text-align: center;
    }
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (max-width: 768px) {
        align-items: center;
    }
`;

export const Title = styled.h3`
    font-size: var(--fontMed);
    color: var(--lightText);
    margin-bottom: 10px;
    position: relative;
    display: inline-block;

    &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 40px;
        height: 2px;
        background: var(--accentGold);
        
        @media (max-width: 768px) {
            left: 50%;
            transform: translateX(-50%);
        }
    }
`;

export const MinggoTitle = styled(Title)`
    &::after {
        background: #ff7a00;
    }
`;

export const ContactItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 15px;
    color: #a1a1aa;
    font-size: var(--fontSmall);
    transition: color 0.3s ease;
    line-height: 1.5;

    span {
        flex: 1;
        min-width: 0;
        word-break: break-word;
    }

    &:hover {
        color: var(--lightText);
    }

    @media (max-width: 768px) {
        justify-content: flex-start;
        text-align: left;
        max-width: 320px;
        margin: 0 auto;
        width: 100%;
    }
`;

export const DetailImg = styled.img`
    width: 24px;
    height: 24px;
    filter: invert(1) opacity(0.7);
    transition: all 0.3s ease;
    flex-shrink: 0;

    ${ContactItem}:hover & {
        filter: invert(1) opacity(1);
        transform: scale(1.1);
    }
`;

export const MapLink = styled.a`
    display: inline-block;
    font-size: 0.9rem;
    font-weight: 500;
    color: ${({ $accent }) => $accent || "var(--accentGold)"} !important;
    cursor: pointer;
    transition: opacity 0.2s ease;
    text-decoration: none;

    &:hover {
        opacity: 0.85;
        text-decoration: underline;
    }
`;

export const Copyright = styled.div`
    text-align: center;
    padding-top: 20px;
    color: #52525b;
    font-size: 0.9rem;
`;
